import 'react-loading-skeleton/dist/skeleton.css'

import Skeleton from 'react-loading-skeleton'
import styled from 'styled-components'

import useMediaQuery from '@/shared/hooks/useMediaQuery'
import { mediaMobile, mediaTablet } from '@/styles/mediaQuery'

export const ItemListSkeleton = ({ count = 4 }: { count?: number }) => {
  const { isMobile } = useMediaQuery()
  return (
    <List>
      {Array.from({ length: count }).map((_, idx) => (
        <Item key={idx}>
          <Skeleton height={isMobile ? 50 : 70} />
        </Item>
      ))}
    </List>
  )
}

const List = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 16px;

  ${mediaTablet} {
    gap: 8px;
  }
`

const Item = styled.li`
  padding: 4px 0;
`

export const CardListSkeleton = ({ count = 4 }: { count?: number }) => {
  return (
    <Grid>
      {Array.from({ length: count }).map((_, idx) => (
        <CardWrap key={idx}>
          <Skeleton height={160} />
        </CardWrap>
      ))}
    </Grid>
  )
}

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;

  ${mediaMobile} {
    grid-template-columns: 1fr;
  }
`

const CardWrap = styled.div`
  border-radius: 12px;
  overflow: hidden;
  background-color: #fff;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
`

export const ItemDetailSkeleton = () => {
  return (
    <Wrap>
      <Skeleton height={32} width="70%" />
      <Skeleton height={18} width="80%" />
      <Skeleton height={180} width="100%" style={{ borderRadius: 8 }} />
    </Wrap>
  )
}

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 80px;
`
